import { Link } from 'react-router-dom'
import Translation from '../Translation/cont/Translation'

const ChooseWeekButtons =({activeWeek, weeks, path, updateWeek, isLink=true, activeWeekIsLink = false, pathAfterWeek=false, customPeriodActive = false}) => ( 
    <div className="title-list gap-30 set-week-buttons">
        {weeks.map(({isoWeek}) => {
            const activeClass = !customPeriodActive && activeWeek === isoWeek ? 'active' : '' 

            return !activeWeekIsLink && activeWeek === isoWeek ? (
                <div key={isoWeek} className={"button-wrapper"}>
                        <div className={"button no-click button-text " + activeClass}><Translation id="print_week"/> {isoWeek}</div>
                </div>
            ) : isLink ? (
                <Link key={isoWeek} className={"button-wrapper"} to={pathAfterWeek ? `${path}/${isoWeek}/${pathAfterWeek}` : `${path}/${isoWeek}`}>
                        <button onClick={() => updateWeek(isoWeek)} className={"button button-text " + activeClass}><Translation id="print_week"/> {isoWeek}</button>
                </Link>
            ) : (
                <div key={isoWeek} className={"button-wrapper"}>
                    <div className={"button button-text " + activeClass} onClick={() => updateWeek(isoWeek)}><Translation id="print_week"/> {isoWeek}</div>
                </div>
            )
        })}
    </div>
)

export default ChooseWeekButtons